const ACCEPTED_MARK = /[\u3007\u25CB]/;

const getConsentSelects = (form: HTMLFormElement) => {
  return Array.from(form.elements).filter(
    (element): element is HTMLSelectElement =>
      element instanceof HTMLSelectElement &&
      element.hasAttribute("data-consent-notice"),
  );
};

export const validateConsentNotices = (form: HTMLFormElement) => {
  for (const select of getConsentSelects(form)) {
    const selectedText = select.selectedOptions[0]?.text ?? "";

    if (!select.value || !ACCEPTED_MARK.test(selectedText)) {
      return (
        select.dataset.consentError || "確認・了承した項目を選択してください"
      );
    }
  }

  return false;
};

export const syncConsentSubmitButton = (form: HTMLFormElement) => {
  if (!getConsentSelects(form).length) return;

  const button = form.querySelector<HTMLButtonElement>('[name="add"]');
  const isButtonDisabled =
    !button ||
    button.hasAttribute("data-unavailable") ||
    button.hasAttribute("data-inquiry-only");

  if (isButtonDisabled) {
    return;
  }

  if (validateConsentNotices(form)) {
    button.disabled = true;
    return;
  }

  button.disabled = false;
};

export const initConsentSubmitButtons = () => {
  document.addEventListener("change", (event) => {
    const target = event.target;
    if (
      !(target instanceof HTMLSelectElement) ||
      !target.hasAttribute("data-consent-notice")
    ) {
      return;
    }

    const form = target.form;
    if (form) syncConsentSubmitButton(form);
  });

  document
    .querySelectorAll<HTMLFormElement>('form[data-type="add-to-cart-form"]')
    .forEach(syncConsentSubmitButton);
};
